import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AgGridModule } from "@ag-grid-community/angular";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { ComponentsModule } from "src/app/components/components.module";
import { AgGridComponentsModule } from "../ag-grid-components/ag-grid-components.module";
import { AngularMaterialModule } from "./../modules/angular-material/angular-material.module";
import { BulkImportComponent } from "./bulk-import/bulk-import.component";
import { GridWrapperHeaderComponent } from "./grid-wrapper-header/grid-wrapper-header.component";
import { GridWrapperComponent } from "./grid-wrapper/grid-wrapper.component";
import { SmartDataGridComponent } from "./smart-data-grid/smart-data-grid.component";
import { BulkImportReviewComponent } from "./bulk-import/bulk-import-review/bulk-import-review.component";

@NgModule({
  declarations: [
    GridWrapperComponent,
    BulkImportComponent,
    BulkImportReviewComponent,
    GridWrapperHeaderComponent,
    SmartDataGridComponent,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    AgGridComponentsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    FormsModule,
    RouterModule,
    AgGridModule,
    MatTooltipModule,
  ],
  exports: [
    GridWrapperComponent,
    GridWrapperHeaderComponent,
    SmartDataGridComponent,
  ],
})
export class DataGridModule {}
